"use strict";
(function (global) {

  global.explorer = {
    _jMainContainer: null,
    _jFilterContainer: null,
    _jSpinner: null,

    /**
     * Инициализирует проводник.
     *
     * @method Core.pages.explorer.init
     */
    init: function () {
      var me = this;

      // TODO перенести в текущий объект
      InitToolbar();
      InitExplorerSidebar();
      InitFolderCover();
      window.name = 'explorer';

      // Установить текущее состояние для истории, если его еще нет.
      me.setCurrentState();

      // Обновление содержимого окна.
      WA.history.bind(WA.history.EVENT.CHANGE_STATE, function (state) {
        if (state && state.type === 'explorer' && state.folderID) {
          me.openFolder(state);
        } else {
          // Если state не определен - перезагружаем окно.
          window.location.reload();
        }
      });

      me._jMainContainer = $('#main_container .MainContentPlaceHolder');
      me._jFilterContainer = $("#QFilter");
      me._jSpinner = $('#main_container .explorer-spinner');

      me._initFolderTreeScroll();
      me._initExpandFolderTree();
      
      me._setToolbarButtonsEnabledState();
    },

    /**
     * Загружает указанную папку.
     *
     * @method Core.pages.explorer.openFolder
     * @param {object} folder
     */
    openFolder(folder) {
      var me = this;
      me._jMainContainer.empty();      
      let folderMode = folder.folderMode || window.FOLDER_MODE.NONE;
      WA.SRV.request('/Folder.asmx/ContentAsHtml', {
        FolderId: folder.folderID,
        FolderMode: folderMode
      }).done((content) => {
        WA.CR.ID = folder.folderID;

        // Скрыть предыдущее сообщение об ошибке
        WA.CR.inlineHint.hide();

        // Панель фильтрации
        this._jFilterContainer.html(content.Filter);
        if (content.FilterJs) {
          _exec(content.FilterJs);
        }
        Core.footer
          .initFastSearchFilter()
          .initViewSwitchingMenu();
        Core.toolBars.objectList.initPreFiltersMenu();

        // Основной контент.
        this._jMainContainer.html(content.Main);
        if (content.MainJs) {
          _exec(content.MainJs);
        }

        this._hideSpinner();

        // Выделить узел дерева
        if (folder.path) {
          WA.CR.folderTree.selectNodeByPath(folder.path);
        }

        // Обновить счетчик непрочитанных для текущей папки
        WA.CR.folderTree.updateUnreadJobCount(folder.folderID);

        // Заголовок
        this.setTitle(folder.title);

        // Применить кастомные стили для обложки
        let jRightColumn = $('#right_column');
        const hasCoverSelector = 'folder_has_cover';
        if (content.HasCover) {
          let jCoverFrame = $('#folder_cover_frame');
          changeCoverStylesImages(jCoverFrame);
          jRightColumn.addClass(hasCoverSelector);
        } else {
          jRightColumn.removeClass(hasCoverSelector);
        }

        let hideButtons = [];
        let showButtons = [];
        switch (folder.contentType) {
          case 'Job':
            showButtons.push(WA.CR.toolBar.buttons['MarkAsRead']);
            break;
          case 'EDocument':
            //Если текущая папка допускает в качестве контента только документы, то скрываем кнопку пометить как прочитанное.
            hideButtons.push(WA.CR.toolBar.buttons['MarkAsRead']);
            break;
          case 'ComponentToken':
          case 'Task':
            //Если текущая папка допускает в качестве контента только варианты запуска, то скрываем кнопки пометить как прочитанное.
            hideButtons.push(WA.CR.toolBar.buttons['MarkAsRead']);
            break;
          default:
            showButtons.push(WA.CR.toolBar.buttons['MarkAsRead']);
        }

        //Прячем и отображаем необходимые кнопки.
        hideButtons.forEach((button) => {
          if (!!button)
            button.hide();
        });

        showButtons.forEach((button) => {
          if (!!button)
            button.show();
        });

        // Удаляем с тулбара действия предыдущей папки и добавляем текущие если есть.
        let group = WA.CR.toolBar.groups['TOOLBAR_CONTENTS_ACTIONS_GROUP'];
        if (group) {
          let buttons = group.getButtons().toArray();
          buttons.forEach((button) => {
            WA.CR.toolBar.buttons.remove(button.name);
          });
          let actionsModels = JSON.parse(content.ContentsActions);

          actionsModels.forEach((actionModel) => {
            let button = group.createButton({
              name: actionModel.name,
              text: actionModel.caption,
              icon: actionModel.icon,
              jsaction: new Function(actionModel.jsAction),
              contentsActionEnabledMode: actionModel.contentsActionEnableMode
            });
            button.setHints(actionModel.hint, actionModel.disabledHint);
            if (actionModel.isCaptionVisible) {
              button.showCaption();
            } else {
              button.hideCaption();
            }
          });
          me._setToolbarButtonsEnabledState();
                    
          // Вписать панель действия по размеру окна с учетом прикладных действий
          WA.CR.toolBar.resizeToolbar();
                       
        }

        folder.folderMode = this.getCurrentViewFolderMode();
        this.updateOrApplyGridOptions(folder.folderID, folder.folderMode);
        InitTooltips();

        // Пересчитать размеры элементов
        window.setRealHeightAndWidth();
      }).fail((msg) => {
        WA.CR.inlineHint.showError(msg);
      });

      function _exec(func) {
        let f = new Function(func);
        setTimeout(function () {
          f.apply(window);
        }, 10);
      }
    },

    /**
     * Сохраняет или восстанавливает режим отображения папки.
     * Восстанавливает сохранённые в localStorage настройки ширин колонок в режиме грида.
     * Если настроек нет, создаёт новые со значениями по умолчанию.
     * Применяет значения к разметке.
     * Возвращает текущий режим отображения папки.
     *
     * @method Core.pages.explorer.updateOrApplyGridOptions
     * @param {number} folderId - ID папки.
     * @param {number} [folderMode] - режим отображения папки (см. FOLDER_MODE).
     * @returns {number} режим отображения папки (см. FOLDER_MODE).
     * @since 5.6.0.9057
     */
    updateOrApplyGridOptions(folderId, folderMode) {
      const localStorageKey = window.FOLDER_GRID.WIDTHS_STORAGE_KEY;

      let gridWidths = JSON.parse(localStorage.getItem(localStorageKey)) || {};
      if (!gridWidths[ folderId ]) {
        gridWidths[ folderId ] = {};
      }
      let folderWidths = gridWidths[ folderId ];

      let storedMode = folderWidths[ window.FOLDER_GRID.FOLDER_MODE_KEY ];
      if ([ window.FOLDER_MODE.COVER, window.FOLDER_MODE.LIST, window.FOLDER_MODE.GRID ].includes(folderMode)) {
        if (!storedMode || storedMode !== folderMode) {
          folderWidths[ window.FOLDER_GRID.FOLDER_MODE_KEY ] = folderMode;
          localStorage.setItem(localStorageKey, JSON.stringify(gridWidths));
        }
      } else {
        folderMode = storedMode;
      }

      // уходим, если режим отображения папки отличен от грида
      if (folderMode !== window.FOLDER_MODE.GRID) {
        return folderMode;
      }

      // будем обрабатывать только объекты вида Документ
      let jObjectListItems = $('.object-list-item[kind=EDoc]');

      // подготовить список колонок на основании разметки с сервера
      let isLocalStorageOutdated = false;
      let jObjectListItemColumns = jObjectListItems.find('.object-list-item__addreq-item');
      jObjectListItemColumns.each((index, element) => {
        const currentWidth = folderWidths[ $(element).data().name ];
        if (!currentWidth) {
          folderWidths[ $(element).data().name ] = window.FOLDER_GRID.DEFAULT_COLUMN_WIDTH;
          isLocalStorageOutdated = true;
        }
      });
      if (isLocalStorageOutdated) {
        localStorage.setItem(localStorageKey, JSON.stringify(gridWidths));
      }

      // применить сохранённые ширины к новым объектам
      for (let dataName in folderWidths) {
        let jObjectListItemColumns = jObjectListItems.find(`[data-name='${dataName}']:not(.grid-cell)`);
        if (jObjectListItemColumns.length) {
          jObjectListItemColumns
            .addClass('grid-cell')
            .width(folderWidths[ dataName ])
            .resizable({
              handles: 'e',
              minWidth: window.FOLDER_GRID.MIN_COLUMN_WIDTH,
              maxWidth: window.FOLDER_GRID.MAX_COLUMN_WIDTH,
              stop: (event, ui) => this._onCellResizeStop(folderId, event, ui),
            });
        }
      }

      return folderMode;
    },

    /**
     * Обработчик событий измеения размера ячейки грида.
     *
     * @private
     * @param {number} folderId - ID папки.
     * @param {object} event - объект события.
     * @param {object} ui - объект jQueryUI.
     * @since 5.6.0.9061
     */
    _onCellResizeStop(folderId, event, ui) {
      let cellWidth = ui.size.width;
      let dataName = ui.element.data().name;

      // сохраним новую ширину в localStorage
      let gridWidths = JSON.parse(localStorage.getItem(window.FOLDER_GRID.WIDTHS_STORAGE_KEY)) || {};
      if (!gridWidths[ folderId ]) {
        gridWidths[ folderId ] = {};
      }
      let folderWidths = gridWidths[ folderId ];
      folderWidths[ dataName ] = cellWidth;
      localStorage.setItem(window.FOLDER_GRID.WIDTHS_STORAGE_KEY, JSON.stringify(gridWidths));

      // распространим новую ширину по всей колонке
      let jObjectListItems = $('.object-list-item[kind=EDoc]');
      let jObjectListItemColumns = jObjectListItems.find(`[data-name='${dataName}']`);
      if (jObjectListItemColumns.length) {
        jObjectListItemColumns.width(cellWidth);
      }
    },

    /**
     * Устанавливает заголовок текущего окна проводника.
     *
     * @method Core.pages.explorer.setTitle
     * @param {} title
     * @returns {}
     */
    setTitle: function (title) {
      window.document.title = title;
      var folderTitle = $('.explorer-folder-name');
      folderTitle.text(title);
      folderTitle.attr('title', title);
    },

    /**
    * Возвращает заголовок текущего окна проводника.
    *
    * @method Core.pages.explorer.setTitle
    * @returns {}
    */
    getTitle: function (title) {
      return $('.explorer-folder-name').text();
    },

    /**
     * Обновляет текущий список и узел для текущей папки.
     *
     * @method Core.pages.explorer.refreshList
     */
    refreshList: function () {
      var me = this;
      var id = WA.CR.getID();
      WA.CR.objectList.reload().done(function () {
        WA.CR.folderTree.updateNodesWithFolder(id);
        WA.CR.folderTree.updateUnreadJobCount(id);
      });
    },

    /**
     * Берёт режим отображения папки из разметки, из переключателя #current_view.
     *
     * @since 5.6.0.9062
     * @returns {number} Режим отображения папки из разметки.
     */
    getCurrentViewFolderMode() {
      let jCurrentView = $('#current_view');
      if (jCurrentView.length) {
        return jCurrentView.data().fmode;
      }

      return window.FOLDER_MODE.LIST;
    },

    /**
     * Устанавливает history state для текущей страницы проводника.
     *
     */
    setCurrentState() {
      let folderMode = this.getCurrentViewFolderMode();

      // Не устанавливаем текущее состояние для страниц поиска, чтобы при возвращении назад выполнялся поиск.
      if (!history.state && !location.href.toLowerCase().includes('mode=search')) {
        let jMainContainer = $('#main_container .MainContentPlaceHolder');
        let id = WA.CR.getID();
        let title = this.getTitle();
        // Если нет контейнера для списка, то значит в режиме папки.
        let isCover = jMainContainer.find('.object_contents').length === 0;
        // QFilter пустой, если режим "Только обложка"
        let hasCoverOnly = isCover && $('#QFilter').children().length === 0;
        let url = new WA.URL();
        let fpath = url.getParam('fpath');
        this.updateOrApplyGridOptions(id, folderMode);

        WA.history.replaceState({
          type: 'explorer',
          folderID: id,
          folderMode: folderMode,
          title: title,
          path: fpath,
          isCover: isCover,
          hasCoverOnly: hasCoverOnly
        }, title, url.asString());
      } else if (history.state) {
        this.updateOrApplyGridOptions(history.state.folderID, folderMode);
      }
    },

    /*
      * Выполняет быстрый поиск.
      * @method Core.pages.explorer.executeQuickSearch
    */
    executeQuickSearch: function (value) {
      // FIXME: удалить SmartSearch на 5.8
      if (GetParamInURL('ext') === 'TEHKAS') {
        const jQuickSearch = $('.quick-search');
        jQuickSearch.removeClass('quick-search_active');

        const jQuickSearchInput = $('input', jQuickSearch);
        jQuickSearchInput.val('');

        let url = 'https://search.directum.ru/';
        window.open(value ? `${url}?q=${value}` : url);
      } else {
        // TODO: Произвести запись в клиентскую статистику.
        var f = $("form:first");
        var url = f.attr('action');

        ShowTopSpinner(L("SEARCHING"));

        url = ChangeParamInURL(url, 'searchname', 'SrchGeneral');
        url = ChangeParamInURL(url, 'mode', 'search');
        url = RemoveParamInURL(url, 'show');
        url = ChangeParamInURL(url, 'value', value);
        url = ChangeParamInURL(url, 'sort', '-RANK');
        url = ChangeParamInURL(url, 'archival', 'N');
        url = RemoveParamInURL(url, 'uid');
        url = RemoveParamInURL(url, 'refcode');
        url = RemoveParamInURL(url, 'treeitem');

        //Изменяем значение критерия "Текст" в форме поиска на текущее, чтобы оно было доступно при заполнении критерией из формы в компоненте поиска.
        var textCriteriaInput = f.find('input#ctl00_LeftContentPlaceHolder_CurrentSearch_SrchGeneralText');
        if (textCriteriaInput)
          textCriteriaInput.val(value);

        f.attr('action', url);
        f.submit();
      }
    },

    navigateToParentFolder: function () {
      const parentPath = this._getParentFolderPath();
      if (parentPath) {
        let id = parentPath.substring(0, parentPath.indexOf('-'));
        let state = { folderID: id, hasCover: false, hasCoverOnly: false, path: parentPath, title: this.getTitle() };
        let url = `/explorer.aspx?sys=${g_SysCode}&ext=${g_ExtName}&id=${id}&fpath=${parentPath}`;
        WA.history.pushState(state, state.title, url)
      }
    },

    /**
    * Скрыть область с деревом папки
    * @private
    */
    collapseFolderTree: function () {
      $.when(WA.SideBarInit).then(function () {
        WA.CR.sideBar.collapse();
      });
    },

    /**
    * Раскрытие области с деревом папки
    * @private
    */
    expandFolderTree: function () {
      $.when(WA.SideBarInit).then(function () {
        WA.CR.sideBar.expand();
      });
    },
   
    /**
     * Скрывает спиннер.
     * @private
     */
    _hideSpinner: function () {
      var me = this;
      me._jMainContainer.show();
      me._jSpinner.hide();
    },

    /**
     * Инициализирует действие раскрытия области с деревом папок.
     * @private
     */
    _initExpandFolderTree: function () {
      var me = this;
      $("#expand_tree_container, .explorer-header__expand-area").click(function () {
        me.expandFolderTree();
      });
    },

    /**
     * Заменяет стандартный скролл у дерево папок.
     * @private
     */
    _initFolderTreeScroll: function () {
      $("#tree_container").niceScroll({
        cursorcolor: "#d8dce3",
        cursorwidth: "6px",
        cursorborder: "0",
        autohidemode: "false",
        cursorborderradius: "0",
        railpadding: { right: 0 }
      });
    },

    /**
     * Инициализирует кнопку отображения папок в списке страницы.
     * @private
     */
    _initShowFolderInList: function () {

      // Инициализирует клик по кнопке Показать/Скрыть папки в списке.
      function bindShowFoldersInListClick() {
        $("#ShowFoldersInList").bind('click', function () {
          var jShowFoldersInListButton = $("#ShowFoldersInList");
          var selectedSelector = "selected";
          var currentFolderID = WA.current.getID();
          var currentNeedToShow = !jShowFoldersInListButton.hasClass(selectedSelector);

          WA.SRV.call("/Session.asmx/UpdateShowFoldersInList", {
            FolderID: currentFolderID,
            NeedToShow: currentNeedToShow
          }).success(function (result) {
            if (currentNeedToShow) {
              jShowFoldersInListButton.addClass(selectedSelector)
              WA.CR.objectList.setIsShowFolders(true);
            } else {
              jShowFoldersInListButton.removeClass(selectedSelector);
              WA.CR.objectList.setIsShowFolders(false);
            }
            WA.CR.objectList.loadFolderContent(currentFolderID);
          });
        });
      };

      bindShowFoldersInListClick();

      WA.current.objectList
        .bind('onChange', function (selectedItems, allItems) {

          var jShowFoldersInListButton = $("#ShowFoldersInList");
          var selectedSelector = "selected";

          if (location.href.toLowerCase().search('mode=search') < 0) {
            bindShowFoldersInListClick();
            if (WA.CR.objectList.isShowFolders())
              jShowFoldersInListButton.addClass(selectedSelector);
            else
              jShowFoldersInListButton.removeClass(selectedSelector);
          } else {
            jShowFoldersInListButton.hide();
            jShowFoldersInListButton.prev().hide();
          }
        });
    },

    /**
     * Устанавливает состояние Selected/Unselected кнопок отображения папок в списке страницы.
     * @private
     */
    _setShowFolderInListState: function () {
      var jShowFoldersInListButton = $("#ShowFoldersInList");
      var selectedSelector = "selected";

      if (location.href.toLowerCase().search('mode=search') < 0) {
        if (WA.CR.objectList.isShowFolders())
          jShowFoldersInListButton.addClass(selectedSelector);
        else
          jShowFoldersInListButton.removeClass(selectedSelector);
      } else {
        jShowFoldersInListButton.hide();
        jShowFoldersInListButton.prev().hide();
      }
    },

    /**
    * Устанавливает доступность кнопок на ленте
    */
    _setToolbarButtonsEnabledState: function () {
      this._bindContentsButtonsEnablingOnItemsSelect();          

      if (this._getParentFolderPath()) {
        WA.CR.toolBar.buttons['MoveUp'].enable();
      } else {
        WA.CR.toolBar.buttons['MoveUp'].disable();
      }
    },

    /**
    * Устанавливает доступность кнопок на ленте при выделении записей в зависимости от режима доступности.
    @private    
    */
    _bindContentsButtonsEnablingOnItemsSelect: function () {
      WA.CR.objectList.bind('onSelect', (item, checkedItems) => {
        let checkedItemsCount = checkedItems.length;        
        this._setContentsButtonsEnabling(checkedItemsCount);         
      });
    },
    /**
    * Устанавливает доступность кнопок на ленте при выделении записей в зависимости от режима доступности.
    @private    
    */
    _setContentsButtonsEnabling: function (checkedItemsCount) {
      let buttonsEnabledOnlyForOneSelected = WA.CR.toolBar.buttons.getButtonsEnabledOnlyForOneSelected();
      let buttonssEnabledForMultiSelected = WA.CR.toolBar.buttons.getButtonsEnabledForMultiSelected();
      if (checkedItemsCount) {
        Object.keys(buttonssEnabledForMultiSelected).forEach((key) => {
          buttonssEnabledForMultiSelected[key].enable();
        });
      } else {
        Object.keys(buttonssEnabledForMultiSelected).forEach((key) => {
          buttonssEnabledForMultiSelected[key].disable();
        });
      }
      if (checkedItemsCount == 1) {
        Object.keys(buttonsEnabledOnlyForOneSelected).forEach((key) => {
          buttonsEnabledOnlyForOneSelected[key].enable();
        });
      } else {
        Object.keys(buttonsEnabledOnlyForOneSelected).forEach((key) => {
          buttonsEnabledOnlyForOneSelected[key].disable();
        });
      }
    },

    /**
     * Возвращает путь папки на уровень выше
     */
    _getParentFolderPath: function () {
      const path = (new WA.URL()).getParam('fpath');
      return path.substring(path.indexOf('-') + 1);
    }

  };
})(window.Core.pages);
